import { Box } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useEffect, useRef } from "react";
import { handleDonationSuccess } from "@utilities/facebookPixel";




const DonationSuccessPage = ({ isSuccessful, isOfflineDonation }: { isSuccessful: boolean; isOfflineDonation: boolean }) => {

    const firedRef = useRef(false);

    useEffect(() => {
        if (!isSuccessful) return;
        if (typeof window === "undefined") return;

        if (firedRef.current) return;   // already fired once
        firedRef.current = true;

 

        if (isSuccessful) {
            const timer = setTimeout(() => {
                window.location.href = "https://thals.org/";
            }, 3000); // 3000ms = 3 seconds

            return () => clearTimeout(timer); // cleanup
        }
    }, [isSuccessful]);




    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: "center", alignContent: "center", background: "white", width: "90%", height: "100%", mx: "auto", py: 5, borderRadius: 2 }}>
            <Box display={"flex"} justifyContent={"center"} alignContent={'center'} >
                {isSuccessful ? (
                    <CheckCircleOutlineIcon sx={{ fontSize: 80 }} color="success" />
                ) : (
                    <HighlightOffIcon sx={{ fontSize: 80 }} color="error" />
                )}

            </Box>
            <CardContent sx={{ px: 2 }}>
                {/* Successful Message */}
                {isSuccessful ? (
                    <Typography
                        fontFamily={"Outfit, ui-sans-serif, system-ui"}
                        sx={{ textAlign: "center" }}
                    >
                        {isOfflineDonation ? (
                            "Your contribution has been initiated successfully. Shortly, a representative from the Thalassemia Foundation will contact you to collect your generous donation. Thank you for your support!"
                        ) : (
                            "Your contribution has been received successfully. Thank you for your support."
                        )}
                    </Typography>
                ) : (
                    <>
                        {/* Unsuccessful Message (Centered & Bold) */}
                        <Typography
                            fontFamily={"Outfit, ui-sans-serif, system-ui"}
                            sx={{ textAlign: "center", fontWeight: "bold", fontSize: "18px", mb: 2 }}
                        >
                            Unfortunately, the contribution was not successful.
                        </Typography>

                        {/* Notice (Left Aligned & Justified) */}
                        <Typography
                            fontFamily={"Outfit, ui-sans-serif, system-ui"}
                            sx={{ textAlign: "justify" }}
                        >
                            <strong>Notice:</strong> If your credit card transaction is declined, it is most likely that your bank is blocking it due to the international nature of the transaction, as it is originating from Bangladesh.
                            <br /><br />
                            Please make a quick call to your credit card issuer bank to resolve the issue immediately. If you continue to experience difficulties, please reach out to us at
                            <a href="mailto:info@thals.org" style={{ textDecoration: "none", color: "#ce1337", fontWeight: "bold" }}> info@thals.org</a>.
                            <br /><br />
                            Thanks,
                            <br />
                            <strong>Bangladesh Thalassemia Foundation</strong>
                        </Typography>
                    </>
                )}
            </CardContent>


        </Box>
    );
};

export default DonationSuccessPage;
